import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.calendar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-calendar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.calendar/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCalendarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public year: number = new Date().getFullYear();
    public month: number = new Date().getMonth() + 1;
    public events: any[] = [];
    public calendarDays: any[] = [];
    public loaded: boolean = false;
    public selectedDate: string = '';
    public selectedEvents: any[] = [];

    public weekdays: string[] = ['일', '월', '화', '수', '목', '금', '토'];
    public monthNames: string[] = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

    public colorMap: any = {
        blue: 'bg-blue-500',
        yellow: 'bg-yellow-500',
        green: 'bg-green-500',
        red: 'bg-red-500',
        purple: 'bg-purple-500'
    };

    public typeMap: any = {
        todo: 'TODO',
        approval: '결재',
        fund: '조합',
        google: '캘린더'
    };

    public async ngOnInit() {
        await this.service.init();
        await this.loadEvents();
    }

    public async loadEvents() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("events", { year: this.year, month: this.month });
        if (code == 200) {
            this.events = data.events || [];
        }
        this.buildCalendar();
        this.loaded = true;
        await this.service.render();
    }

    public buildCalendar() {
        const firstDay = new Date(this.year, this.month - 1, 1);
        const lastDay = new Date(this.year, this.month, 0);
        const startDow = firstDay.getDay();
        const totalDays = lastDay.getDate();

        this.calendarDays = [];

        // Previous month padding
        for (let i = 0; i < startDow; i++) {
            this.calendarDays.push({ day: 0, date: '', events: [], isToday: false, isCurrentMonth: false });
        }

        const today = new Date();
        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

        for (let d = 1; d <= totalDays; d++) {
            const dateStr = `${this.year}-${String(this.month).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
            const dayEvents = this.events.filter((e: any) => e.date === dateStr);
            this.calendarDays.push({
                day: d,
                date: dateStr,
                events: dayEvents,
                isToday: dateStr === todayStr,
                isCurrentMonth: true
            });
        }

        // Next month padding
        const remaining = 7 - (this.calendarDays.length % 7);
        if (remaining < 7) {
            for (let i = 0; i < remaining; i++) {
                this.calendarDays.push({ day: 0, date: '', events: [], isToday: false, isCurrentMonth: false });
            }
        }
    }

    public async prevMonth() {
        this.month--;
        if (this.month < 1) { this.month = 12; this.year--; }
        await this.loadEvents();
    }

    public async nextMonth() {
        this.month++;
        if (this.month > 12) { this.month = 1; this.year++; }
        await this.loadEvents();
    }

    public async goToday() {
        this.year = new Date().getFullYear();
        this.month = new Date().getMonth() + 1;
        await this.loadEvents();
    }

    public async selectDate(day: any) {
        if (!day.isCurrentMonth) return;
        this.selectedDate = day.date;
        this.selectedEvents = day.events;
        await this.service.render();
    }
}

export default PortalLpsysadminCalendarComponent;